export default function SVG_Image() {
  return (
    <div>
      <h1>SVG_Image Component</h1>
    </div>
  );
}
